import { AlertAction } from "./alertAction";
import { PopAction } from "./popAction";
import { JavaScriptAction } from "./javaScriptAction";
import { BannerAction } from "./bannerAction";
import { SlideAndFadeAction } from "./slideAndFadeAction";
import { EventAction } from "./eventAction";

export var actionRepository = {} as any;

actionRepository["alert"] = {
    action: AlertAction,
    description: "Action är en alertbox",
    params: { text: "" },
    paramsDescription: { text: "Alertboxens innehåll" },
};
actionRepository["pop"] = {
    action: PopAction,
    description: "Action är en popup ruta med en iframe",
    params: {
        elementName: "",
        type: "",
        elementCSS: "",
        el: "",
        id: "",
        elementId: "",
        content: "",
        src: "",
    },
    paramsDescription: {
        elementName: "",
        type: "",
        elementCSS: "",
        el: "",
        id: "",
        elementId: "",
        content: "html här",
        src: "",
    },
};

actionRepository["script"] = {
    action: JavaScriptAction,
    description: "Your own JS as Action",
    params: { externalAction: "" },
    paramsDescription: { externalAction: "your JS Function in here (function(){console.log('this happened')})" },
};

actionRepository["banner"] = {
    action: BannerAction,
    description: "Action är en banner",
    params: { param: "" },
    paramsDescription: { param: "Banner attribute är top eller bottom" },
};

actionRepository["slideAndFade"] = {
    action: SlideAndFadeAction,
    description: "Action är en div som fade eller slide",
    params: { param: "" },
    paramsDescription: { param: "Direction,position eller boolean (right/left/top/bottom/true)" },
};

actionRepository["event"] = {
    action: EventAction,
    description: "Triggar ett customevent",
    params: {
        event: "",
        category: "",
        action: "",
        label: "",
        value: "",
        data: "",
        customEventType: "string",
    },
    paramsDescription: {
        event: "string",
        category: "string",
        action: "string",
        label: "string",
        value: "string",
        data: "Data to post (string, json or function that resolves to string/json)",
        customEventType: "name of event, ex: site.area.event (shop.firstpagebanner.click)",
    },
};

export interface Action {
    execute(): void;
}

export default Action;
